export default __webpack_public_path__ + "static/media/image 61 (1).f7dc18d1.png";